module.exports = __webpack_public_path__ + "static/img/top3.38d06ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top3.jpg
// module id = INU2
// module chunks = 1